import { baseUri } from 'Constants/Constants';

export const sideBarLinks = [
  {
    label: 'Merchants',
    href: `${baseUri}/merchants`,
  },
  {
    label: 'Onboard Merchant',
    href: `${baseUri}/onboard-merchant`,
  },
  {
    label: 'Resend Onboard Merchant Email',
    href: `${baseUri}/resend-email`,
  },
  {
    label: 'Marketplaces',
    href: `${baseUri}/marketplaces`,
  },
  {
    label: 'Overdue Plans',
    href: `${baseUri}/overdue`,
  },
  {
    label: 'Disputes',
    href: `${baseUri}/disputes`,
  },
  {
    label: 'OTP Resets',
    href: `${baseUri}/otp-resets`,
  },
  {
    label: 'Customers',
    href: `${baseUri}/customers`,
  },
  {
    label: 'Blocked Cards',
    href: `${baseUri}/blocked-cards`,
  },
  {
    label: 'Loan Statements',
    href: `${baseUri}/loan-statements`,
  },
  {
    label: 'Invoices',
    href: `${baseUri}/invoices`,
  },
  {
    label: 'Payouts',
    href: `${baseUri}/payouts`,
  },
];
